import * as React from "react"
import { connect } from 'react-redux'

import {
    css,
    Message,
    DataTable,
    DataBody,
    DataCell,
    DataRow,
    TextInput,
    Grid,
    GridCell,
} from "@bdfx/mergado-ui-kit";

import trans from "trans";
import { ImagickFontsReduxList } from "app/reducers/imagickFontsReduxList";
import { IconLightBulb } from "app/icons";

interface Props {
    imagickFonts: ImagickFontsReduxList
}

interface State {
    sampleText: string
    filter: string
}

class Fonts extends React.Component<Props, State> {
    constructor(props) {
        super(props)
        this.state = {
            sampleText: null,
            filter: null,
        }
    }

    render() {
        const { imagickFonts } = this.props
        const { sampleText, filter } = this.state

        const availableFontFamilies = Object.keys(imagickFonts.data.allAvailableFamilies).map((key: string) => ({
            label: imagickFonts.data.allAvailableFamilies[key].family,
            value: imagickFonts.data.allAvailableFamilies[key].family,
            image: imagickFonts.data.allAvailableFamilies[key].image,
            font: imagickFonts.data.allAvailableFamilies[key].text_fontfamily,
            styles: imagickFonts.data.allAvailableFamilies[key].styles,
        }))


        const filteredFonts = filter ? availableFontFamilies.filter(availableFontFamily => availableFontFamily.label.toLowerCase().includes(filter.toLowerCase()) || availableFontFamily.font.toLowerCase().includes(filter.toLowerCase())) : availableFontFamilies

        return <StyledContent>
            <Message type={"warning"} closeable={true} icon={<IconLightBulb size={28} />} text={trans("more_fonts")} />

            <Grid cols={"1fr 1fr"}>
                <GridCell>
                    <TextInput
                        value={sampleText}
                        placeholder={trans('font_example')}
                        onChange={(value) => {
                            this.setState({ sampleText: value })
                        }}
                        onClear={() => {
                            this.setState({ sampleText: null })
                        }}
                    />
                </GridCell>
                <GridCell>
                    <TextInput
                        value={filter}
                        placeholder={trans('filter')}
                        onChange={(value) => {
                            this.setState({ filter: value })
                        }}
                        onClear={() => {
                            this.setState({ filter: null })
                        }}
                    />
                </GridCell>
            </Grid>

            {(filteredFonts && filteredFonts.length > 0) &&
                <StyledDataTable>
                    <DataBody>
                        {filteredFonts.map((fontfamily) =>
                            <DataRow key={fontfamily.value}>
                                <td>{fontfamily.label}</td>
                                <td>
                                    <Example font={fontfamily.font} className="example">
                                        {sampleText ? sampleText : trans("font_example")}
                                    </Example>
                                </td>
                                <td style={{ whiteSpace: 'wrap' }}>
                                    {Object.keys(fontfamily.styles).map((o: string) => o).join(', ')}
                                </td>
                            </DataRow>
                        )}
                    </DataBody>
                </StyledDataTable>
            }
        </StyledContent>
    }
}

const StyledContent = css('div')({
    alignSelf: 'center',
    textAlign: 'left',
})

const Example = css("div")({
    fontSize: "30px",
    borderBottom: "1px solid #eee",
    paddingBottom: "5px",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    lineHeight: "36px",
    height: "36px",
}, props => ({
    fontFamily: "'" + props.font + "', 'Unicode-BMP-Fallback-SIL'"
}))

const StyledDataTable = css(DataTable)({
    height: '300px',
    overflowY: 'auto',
})

function mapStateToProps(state) {
    return {
        imagickFonts: state.imagickFonts,
    }
}

export default connect(mapStateToProps, {})(Fonts)